import { createElement, useEffect, useRef } from 'react'

interface Args extends Omit<IntersectionObserverInit, 'root'> {
  targetRef?: React.RefObject<HTMLElement | undefined | null>
  rootRef?: React.RefObject<HTMLElement | undefined | null>
  onIntersect: () => void
  enabled?: boolean
}

export function useIntersectionObserver({
  targetRef,
  rootRef,
  onIntersect,
  enabled = true,
  ...options
}: Args) {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    const target = targetRef?.current || ref.current
    if (!enabled || !target) return

    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (entry.isIntersecting) onIntersect()
        }),
      { ...options, root: rootRef?.current }
    )

    observer.observe(target)

    return () => {
      observer.unobserve(target)
    }
  }, [enabled, targetRef?.current, ref?.current, rootRef?.current])

  return {
    observerElement: createElement('div', { style: { height: 10 }, ref })
  }
}
